/* Section « Bibliothèque » (mi-library) : interaction liste <-> scène de livres.
   Maquette : js/sections/h08_livre.js (même comportement, sans fetch : prix et identifiants de variante sont rendus par Liquid).
   Survol, focus clavier ou toucher d'un titre ou d'un livre met le livre en avant ; la Box (data-box : lot de trois livres) passe au premier plan seulement quand son titre est actif (ordinateur).
   Écran tactile : un seul toucher ouvre la fiche. Mouvement réduit : les transitions sont coupées par le CSS.
   Éditeur de thème : rescan à shopify:section:load. Aucune dépendance. */
function wire(root) {
  if (!root || root.dataset.miWired) return;
  root.dataset.miWired = '1';
  const stage = root.querySelector('[data-book-stage]');
  if (!stage) return;
  const items = Array.from(stage.querySelectorAll('[data-book]'));
  const links = Array.from(root.querySelectorAll('[data-book-link]'));
  const touch = window.matchMedia('(hover: none)');
  const set = (index) => {
    const key = index === null ? null : String(index);
    const current = key === null ? null : items.find((el) => el.dataset.book === key);
    if (key === null) { stage.removeAttribute('data-active'); stage.removeAttribute('data-active-box'); }
    else {
      stage.dataset.active = key;
      if (current && current.hasAttribute('data-box')) stage.setAttribute('data-active-box', ''); else stage.removeAttribute('data-active-box');
    }
    items.forEach((el) => el.classList.toggle('is-active', el.dataset.book === key));
    links.forEach((a) => a.classList.toggle('is-hot', a.dataset.bookLink === key));
  };
  links.forEach((a) => {
    const i = a.dataset.bookLink;
    a.addEventListener('pointerenter', () => set(i));
    a.addEventListener('pointerleave', () => set(null));
    a.addEventListener('focus', () => set(i));
    a.addEventListener('blur', () => set(null));
  });
  items.forEach((el) => {
    const i = el.dataset.book;
    const cover = el.querySelector('.book__cover');
    el.addEventListener('pointerenter', () => { if (!el.hasAttribute('data-box')) set(i); });
    el.addEventListener('pointerleave', () => { if (!touch.matches) set(null); });
    el.addEventListener('focusin', () => set(i));
    el.addEventListener('focusout', () => set(null));
  });
  const settle = () => setTimeout(() => stage.classList.add('is-settled'), 1600);
  if (stage.classList.contains('is-in')) settle();
  else new MutationObserver((records, observer) => { if (stage.classList.contains('is-in')) { settle(); observer.disconnect(); } }).observe(stage, { attributes: true, attributeFilter: ['class'] });
}

function init(scope) { (scope || document).querySelectorAll('[data-mi-library]').forEach(wire); }
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
